import React from 'react';
import moment from 'moment';
import Lib from 'utils/Lib.js'

export default class TrackingRow extends React.Component {
	render() {
		return (
			<tr>
				<td>{Lib.replaceEmpty(this.props.RowData.Site)}</td>
				<td>{Lib.replaceEmpty(this.props.RowData.Location)}</td>
				<td>{this.props.RowData.DueDate ? moment(this.props.RowData.DueDate).format('ll') : '-'}</td>
				<td>{Lib.replaceEmpty(this.props.RowData.User)}</td>
				<td>{this.props.RowData.ChekinTime ? moment(this.props.RowData.ChekinTime).format('ll') : '-'}</td>
				<td>{this.props.RowData.CheckoutTime ? moment(this.props.RowData.CheckoutTime).format('ll') : '-'}</td>				
			</tr>
		);
	}
}



// WEBPACK FOOTER //
// ./src/App/asset/simple_asset/helper/component/Row/TrackingRow.js